import styled from '@emotion/styled';
import { Col } from 'antd';
import React from 'react';

import { CircularRatesExtended } from 'src/shared/components/CircularRatesExtended';
import { color, font, shadow } from 'src/shared/styles/variables';

import { ValuesAssessmentDomain } from '../models/weekTwo';

export const AreaRatingWrapper = styled(Col)({
    padding: '1rem',
    flexGrow: 1,
});

interface AreaRatingContentProps {
    selected?: boolean;
}

export const AreaRatingContent = styled('div')<AreaRatingContentProps>(({ selected }) => ({
    borderRadius: 7,
    backgroundColor: color.white,
    boxShadow: shadow.lightCardShadow,
    border: `1px solid ${selected ? color.selectiveYellow : color.mercury}`,
    padding: '1.5rem',
    transition: 'border-color 0.2s',
    '&:hover': {
        borderColor: selected ? color.selectiveYellow : color.mercury,
    },
}));

const DomainTitle = styled('h4')(
    {
        color: color.chathamsBlue,
        textTransform: 'capitalize',
    },
    font.heavy(font.size.large),
);

interface AreaRatingProps {
    domain: ValuesAssessmentDomain;
    availablePoints: number;
    onRateExtend: (domainTitle: string, value: number) => void;
}

export class AreaRating extends React.PureComponent<AreaRatingProps> {
    public handleRateExtend = (value: number) => {
        const { domain, onRateExtend } = this.props;

        return onRateExtend(domain.title, value);
    };

    public render(): JSX.Element {
        const { domain, availablePoints } = this.props;
        return (
            <AreaRatingWrapper xs={24} md={12}>
                <AreaRatingContent selected={!!domain.additionalRate}>
                    <DomainTitle>{domain.title}</DomainTitle>
                    <CircularRatesExtended
                        range={domain.rate === 5 ? 6 : 5}
                        initialRate={domain.rate}
                        additionalRate={domain.additionalRate}
                        availablePoints={availablePoints}
                        onRateExtend={this.handleRateExtend}
                    />
                </AreaRatingContent>
            </AreaRatingWrapper>
        );
    }
}
